var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _rect, _rect2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSingleCuffsTwoButton(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 37.4223L17.9098 23.5125C24.4784 23.1261 30.2741 26.99 34.3312 34.5244",
    stroke: "#757575",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.7166 23.5124C17.7166 23.3578 27.7625 10.4397 32.7855 4",
    stroke: "#757575",
    strokeWidth: 1.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.1602 23.7056C23.5928 21.3245 24.5326 20.2416 26.4104 18.6826",
    stroke: "#757575",
    strokeWidth: 1.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M33.9448 33.3657C38.9888 27.7362 42.54 25.5448 48.0478 20.4219C43.0992 26.4117 40.2809 29.7064 34.5244 34.5249",
    stroke: "#757575",
    strokeWidth: 1.5
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M35.8767 37.8107C37.7625 36.4169 38.784 35.6054 40.1269 33.7537",
    stroke: "#757575",
    strokeWidth: 1.5
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M35.8767 42.8303C37.7202 42.6806 50.9376 30.1528 56.7415 23.3179",
    stroke: "#757575",
    strokeWidth: 1.5
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M22.1602 46.8883L23.5125 45.536C25.8388 49.9855 26.2174 52.4911 23.5126 55.7754C14.819 58.2869 1.68176 42.2514 4.38653 37.2284C7.47777 34.1375 14.2992 36.5746 22.1602 46.8883Z",
    stroke: "#757575",
    strokeWidth: 1.5
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M34.3307 34.7156L23.512 45.5343C24.981 48.4351 25.3109 50.3719 25.2507 54.228L36.0695 42.8296C36.4431 39.0253 36.0484 37.2413 34.3307 34.7156Z",
    stroke: "#757575",
    strokeWidth: 1.5
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M23.971 38.4147C23.7803 38.8777 23.1201 39.2026 22.3885 38.9013C21.6569 38.5999 21.4171 37.9043 21.6078 37.4414C21.7985 36.9784 22.4586 36.6535 23.1903 36.9548C23.9219 37.2561 24.1617 37.9517 23.971 38.4147Z",
    fill: "#757575",
    stroke: "#757575",
    strokeWidth: 1.5
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M27.7722 35.0851C27.5815 35.5481 26.9214 35.873 26.1898 35.5717C25.4582 35.2703 25.2184 34.5747 25.4091 34.1118C25.5998 33.6488 26.2599 33.3239 26.9915 33.6252C27.7231 33.9265 27.9629 34.6221 27.7722 35.0851Z",
    fill: "#757575",
    stroke: "#757575",
    strokeWidth: 1.5
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 20.4074,
    y: 36.0002,
    width: 0.193192,
    height: 6.44706,
    transform: "rotate(-45 20.4074 36.0002)",
    fill: "#757575",
    stroke: "#757575",
    strokeWidth: 0.193192
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 24.2086,
    y: 32.6707,
    width: 0.193192,
    height: 6.44706,
    transform: "rotate(-45 24.2086 32.6707)",
    fill: "#757575",
    stroke: "#757575",
    strokeWidth: 0.193192
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSingleCuffsTwoButton);
export default __webpack_public_path__ + "static/media/single_cuffs_two_button.f6791c0be7304880b56e38798985f47d.svg";
export { ForwardRef as ReactComponent };